import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';

export const CMS_CONFIG_APPLEPAY = 'apple-pay';

export interface ICmsConfigApplePayDataContent {
    showApplePay?: string;
}

ICmsContentService.registerConfig({
    id: CMS_CONFIG_APPLEPAY,
    name: 'Apple Pay Configuration',
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-apple-pay',
            title: 'Apple Pay'
        },
        <NICmsContentField.IToggleField>{
            key: 'showApplePay',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Show Apple Pay',
            labels: { true: 'Yes', false: 'No' },
            default: false
        }
    ]
});
